import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { SectionContainer } from '../ui/SectionContainer';
import { FeatureCard } from '../ui/FeatureCard';
import { OUR_VALUES } from '../../constants';

interface ValuesSectionProps {
  compact?: boolean;
}

/**
 * Our Values section for the About page
 * Displays the company's core values
 */
export const ValuesSection: React.FC<ValuesSectionProps> = ({ compact = false }) => {
  return (
    <SectionContainer variant="default" compact={compact}>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            mb: 2,
            fontSize: { xs: '1.75rem', md: '2rem' },
          }}
        >
          Our Values
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {OUR_VALUES.map((value) => (
          <Grid item key={value.title} xs={12} sm={6} md={3}>
            <FeatureCard icon={value.icon} title={value.title} description={value.description} />
          </Grid>
        ))}
      </Grid>
    </SectionContainer>
  );
};
